import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '@/ui/_lib/Container';
import { useUser } from '@/contexts/UserContext/UserContext';
import CompleteProfileForm from '@/ui/components/complete-profile/Form';

export default function CompleteProfile() {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has a title
    if (!user?.title) {
      // Redirect to profile title page
      navigate('/profile-title');
      return;
    }
    
    // Check if profile is already complete
    if (user?.profileComplete) {
      // Redirect to choose template page
      navigate('/choose-template');
    }
  }, [user, navigate]);

  // Don't render the form if user doesn't have a title or profile is already complete
  if (!user?.title || user?.profileComplete) {
    return null;
  }

  return (
    <Container className="flex h-full w-full items-center justify-center">
      <div className="flex w-full max-w-md flex-col gap-4">
        <CompleteProfileForm />
      </div>
    </Container>
  );
}